import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ToastNotificationService } from '../../../services/toast-notification.service';
import { ToastNotification } from '../../../models/toast-notification';
import { ToastNotificationType, ToastPosition } from '../../../models/toast-notification-type';
import { ToastNotificationComponent } from "../toast-notification/toast-notification.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast-notifications-container',
  imports: [CommonModule, ToastNotificationComponent],
  templateUrl: './toast-notifications-container.component.html',
  styleUrl: './toast-notifications-container.component.css'
})
export class ToastNotificationsContainerComponent implements OnInit {
  notificationService = inject(ToastNotificationService);
  notifcations: ToastNotification[] = [];

  ToastNotificationType = ToastNotificationType;
  ToastPosition = ToastPosition;
  positions = Object.values(ToastPosition);

  groupedNotifications: Record<string, ToastNotification[]> = {
    [ToastPosition.TOP_LEFT]: [],
    [ToastPosition.TOP_RIGHT]: [],
    [ToastPosition.TOP_CENTER]: [],
    [ToastPosition.BOTTOM_LEFT]: [],
    [ToastPosition.BOTTOM_RIGHT]: [],
    [ToastPosition.BOTTOM_CENTER]: []
  };

  ngOnInit(): void {
    this.notificationService.notifications.subscribe((notification: ToastNotification | null) => {
      if (!notification) return;

      const position = notification.position ?? ToastPosition.BOTTOM_LEFT;
      this.groupedNotifications[position].push(notification);
    });
  }

  removeNotification(notification: ToastNotification, position: ToastPosition) {
    this.groupedNotifications[position] = this.groupedNotifications[position].filter(n => n !== notification);
  }

  getPositionClasses(position: ToastPosition) {
    switch (position) {
      case ToastPosition.TOP_LEFT:
        return 'top-5 left-4';

      case ToastPosition.TOP_RIGHT:
        return 'top-5 right-4';

      case ToastPosition.TOP_CENTER:
        return 'top-5 left-1/2 -translate-x-1/2';

      case ToastPosition.BOTTOM_LEFT:
        return 'bottom-5 left-4';

      case ToastPosition.BOTTOM_RIGHT:
        return 'bottom-5 right-4';

      case ToastPosition.BOTTOM_CENTER:
        return 'bottom-5 left-1/2 -translate-x-1/2';

      default:
        return '';
    }
  }

}

